export default __webpack_public_path__ + "files/f7243c95643ef324647e6bed6e5040c0.png";